import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AbstractTransformerService } from "../abstract-transformer.service";

export enum FIND_REPLACE_ACTIONS {
  REPLACE = "REPLACE",
  REMOVE = "REMOVE",
  DELETE_ROWS = "DELETEROWS",
}

// export interface FindReplaceState {
//   columnId: string;
//   findText: string;
//   replaceText: string;
// }

@Injectable({ providedIn: "root" })
export class FindReplaceService extends AbstractTransformerService {
  private _columnId$ = new BehaviorSubject<string | null>(null);
  private _findText$ = new BehaviorSubject<string>("");
  private _replaceText$ = new BehaviorSubject<string>("");
  public get columnId$() {
    return this._columnId$.asObservable();
  }
  public get findText$() {
    return this._findText$.asObservable();
  }
  public get replaceText$() {
    return this._replaceText$.asObservable();
  }

  public get columnId(): string | null {
    return this._columnId$.getValue();
  }
  public set columnId(id: string | null) {
    this._columnId$.next(id);
  }
  public get findText(): string {
    return this._findText$.getValue();
  }
  public set findText(txt: string) {
    this._findText$.next(txt);
  }
  public get replaceText(): string {
    return this._replaceText$.getValue();
  }
  public set replaceText(txt: string) {
    this._replaceText$.next(txt);
  }

  override reset() {
    super.reset();
    this.columnId = null;
    this.findText = "";
    this.replaceText = "";
  }
}
